import { ReactNode } from 'react';
import Menu from '../Menu';
import * as Style from './style';
import { MenuItem } from 'menu/MenuItem';

interface DropdownMenuProps {
	menuItems: MenuItem[];
	children: ReactNode | string;
	side?: 'top' | 'right' | 'bottom' | 'left';
}

const DropdownMenu = ({ menuItems, children, side = 'bottom' }: DropdownMenuProps) => {
	return (
		<Menu
			menuItems={menuItems}
			Style={Style}
			side={side}
			sideOffset={6}
			align="start"
		>
			{children}
		</Menu>
	);
};

export default DropdownMenu;
